var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivateCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,65.098041%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 20.8125 22.5 L 3.1875 22.5 C 2.253906 22.5 1.5 21.746094 1.5 20.8125 L 1.5 10.6875 C 1.5 9.757812 2.253906 9 3.1875 9 L 20.8125 9 C 21.746094 9 22.5 9.753906 22.5 10.6875 L 22.5 20.8125 C 22.5 21.261719 22.324219 21.691406 22.007812 22.007812 C 21.691406 22.324219 21.261719 22.5 20.8125 22.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.686275%,95.686275%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 17.539062 18 L 4.210938 18 C 3.957031 18 3.75 17.792969 3.75 17.539062 L 3.75 15.460938 C 3.75 15.210938 3.953125 15 4.210938 15 L 17.539062 15 C 17.789062 15 18 15.203125 18 15.460938 L 18 17.546875 C 18 17.796875 17.792969 18 17.539062 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,95.686275%,47.058824%)",
      fillOpacity: 1
    },
    d: "M 19.015625 21 L 20.359375 21 C 20.53125 21 20.691406 20.933594 20.8125 20.8125 C 20.933594 20.691406 21 20.53125 21 20.359375 L 21 19.015625 C 21 18.84375 20.933594 18.683594 20.8125 18.5625 C 20.691406 18.441406 20.53125 18.375 20.359375 18.375 L 19.015625 18.375 C 18.84375 18.375 18.683594 18.441406 18.5625 18.5625 C 18.441406 18.683594 18.375 18.84375 18.375 19.015625 L 18.375 20.359375 C 18.378906 20.710938 18.664062 20.996094 19.015625 21 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(19.607843%,10.588235%,25.490198%)",
      fillOpacity: 1
    },
    d: "M 22.5 11.25 L 1.5 11.25 L 1.5 13.5 L 22.5 13.5 Z M 22.5 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784316%,60.784316%,60.784316%)",
      fillOpacity: 1
    },
    d: "M 4.5 16.5 C 4.5 16.292969 4.667969 16.125 4.875 16.125 L 13.125 16.125 C 13.332031 16.125 13.5 16.292969 13.5 16.5 C 13.5 16.707031 13.332031 16.875 13.125 16.875 L 4.875 16.875 C 4.667969 16.875 4.5 16.707031 4.5 16.5 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateCard);
export default __webpack_public_path__ + "static/media/ActivateCard.08cde6e155fb4717f8258e3cd85c719d.svg";
export { ForwardRef as ReactComponent };